<template>
</template>
<script>

const ajaxagent = require('superagent');
import { FileUploadService } from 'v-file-upload'

export default {
    name: "core-ajax",
    props: {
        debug: {
          type: Boolean,
          default: !1
      },
      isfile: {
          type: Boolean,
          default: !1
      },

        auto: {
            type: Boolean,
            default: !0
        },
        src: {
            type: String,
            default: ""
        },
        state: {
            type: String,
            default: "ajax:"
        },
        method: {
            type: String,
            default: "get"
        },
        contentType: {
            type: String,
            default: "application/json"
        },
        data: {
            type: Object,
            default: function() {
                return this.data
            }
        },
        headers: {
            type: Object,
            default: function() {
                return this.headers
            }
        },
        onSuccess: {
            type: Function,
            default: function() {}
        },
        onError: {
            type: Function,
            default: function() {}
        }
    },
    watch: {
        data: "load",
        src: "load"
    },
    mounted: function() {
        this.debug&&console.log("call method Cycle Mount cor-ajax");
        this.auto && null !== this.src && this.load()
    },
    methods: {
      onProgress(event) {


       },
        load: function()
        {

          this.debug&&console.log("call method Cycle Load Ajax"+this.data);
            var t = this;
            if ("" !== this.src && "get" === this.method)
             ajaxagent.get(this.src).query(this.data).end(function(e, n) {  e ? t.$emit("on:error", e) : t.$emit("on:success", n)  });
                //ajaxagent.get(this.src).query(this.data).set(void 0 === this.headers ? "" : this.headers).end(function(e, n) {  e ? t.$emit("on:error", e) : t.$emit("on:success", n)  });
            else
            {
      

                if(this.isfile)
                {
                    t.$emit("on:startfileupload",   "valid")
                    //console.log(this.data.fileCV);
                    let fileUpload = new FileUploadService( this.src, this.onProgress)
                    fileUpload
                    .upload(this.data.fileCV[0], { Jobtitle: this.data.Jobtitle, Company: this.data.Company })
                    .then(e => {
                        // Handle success
                        //console.log(e);

                        t.$emit("on:success",   "valid")
                        })
                        .catch(e => {
                        t.$emit("on:error", e)
                        // Handle error
                        })
                }
                else
                {
                    if ("" === this.src || void 0 === this.data) return;
                    ajaxagent.post(this.src).send(this.data).type(this.contentType).end(function(e, n)
                    {
                    e ? t.$emit("on:error", e) : t.$emit("on:success", n)
                    })
                }

                
            }

        }
    }
}

</script>
